<template>
  <div class="nrent-page">
    <main-header :hasBanner="true" :type="'nrent'"></main-header>
    <section class="main-center">
      <div class="search-box">
        <div class="search-item">
          <div class="search-item-left">
            <img src="@/assets/img/search-d.png" alt="" />
            区域
          </div>
          <div class="search-item-right">
            <a v-for="item in cityList" :key="item.value" href="#/nrent/list">{{
              item.label
            }}</a>
          </div>
        </div>
        <div class="search-item">
          <div class="search-item-left">
            <img src="@/assets/img/search-x.png" alt="" />
            租金
          </div>
          <div class="search-item-right">
            <a v-for="item in moneyList" :key="item.id" href="#/nrent/list">{{
              item.label
            }}</a>
          </div>
        </div>
        <div class="search-item">
          <div class="search-item-left">
            <img src="@/assets/img/search-b.png" alt="" />
            其他
          </div>
          <div class="search-item-right">
             <a v-for="item in otherList" :key="item.id" href="#/nrent/list">{{
              item.label
            }}</a>
          </div>
        </div>
      </div>
      <div class="listing-box">
        <div class="listing-title">租赁房挂牌交易量</div>
        <div class="listing-list">
          <div class="listing-item">
            <div class="listing-number">12</div>
            <div class="listing-label">本月挂牌量</div>
          </div>
          <div class="listing-item">
            <div class="listing-number">21</div>
            <div class="listing-label">上月挂牌量</div>
          </div>
          <div class="listing-item">
            <div class="listing-number">2366</div>
            <div class="listing-label">总挂牌量</div>
          </div>
          <div class="listing-item">
            <div class="listing-number">2366</div>
            <div class="listing-label">本月交易量</div>
          </div>
          <div class="listing-item">
            <div class="listing-number">2366</div>
            <div class="listing-label">上月交易量</div>
          </div>
          <div class="listing-item">
            <div class="listing-number">2366</div>
            <div class="listing-label">总交易量</div>
          </div>
        </div>
      </div>

      <div class="flex-box-bt">
        <div class="origin-box">
          <div class="home-item-title">
            <div>租房挂牌</div>
            <div class="more">更多 ></div>
          </div>
          <el-table :data="resourcesTable" style="width: 100%">
            <el-table-column prop="address" label="核验编码"></el-table-column>
            <el-table-column prop="housetypename" label="小区">
            </el-table-column>
            <el-table-column prop="architarea" label="面积"> </el-table-column>
            <el-table-column prop="architarea" label="租金"> </el-table-column>
            <el-table-column prop="startDate" label="挂牌来源">
            </el-table-column>
            <el-table-column prop="startDate" label="挂牌时间">
            </el-table-column>
          </el-table>
        </div>

        <div class="tips-box">
          <div class="home-item-title" style="margin-bottom:24px">
            <div>合同查询</div>
          </div>
          <el-input placeholder="请输入合同编号"></el-input>
          <el-button style="margin-top: 24px" type="primary">查询</el-button>
        </div>
      </div>
    </section>
    <div style="height: 42px"></div>
    <main-footer></main-footer>
  </div>
</template>

<script>
import { districtList } from "@/assets/api/common";
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
export default {
  name: "nrentIndex",
  components: {
    mainHeader,
    mainFooter,
  },
  data() {
    return {
      cityList: [],
      moneyList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "3000以下",
          label: "3000以下",
        },
        {
          value: "3000-4000",
          label: "3000-4000",
        },
        {
          value: "4000-5000",
          label: "4000-5000",
        },
        {
          value: "5000-6000",
          label: "5000-6000",
        },
        {
          value: "6000-8000",
          label: "6000-8000",
        },
      ],
      otherList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "两室两厅",
          label: "两室两厅",
        },
        {
          value: "三室一厅",
          label: "三室一厅",
        },
        {
          value: "四室一厅",
          label: "四室一厅",
        },
        {
          value: "70-90m²",
          label: "70-90m²",
        },
        {
          value: "120-150m²",
          label: "120-150m²",
        },
      ],
      resourcesTable: ['','','','','','','','','',]
    };
  },
  mounted() {
    this.initCity();
  },
  methods: {
    async initCity() {
      const res = await districtList();
      this.cityList = ((res && res.data && res.data.data) || []).map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });
      this.cityList.unshift({
        value: null,
        label: "全部",
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.nrent-page {
  .search-box {
    border: 1px solid #ececec;
    border-bottom: none;
    .search-item {
      display: flex;
      border-bottom: 1px solid #ececec;
      .search-item-left {
        width: 220px;
        background: #fafafa;
        text-align: center;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        img {
          width: 24px;
          margin: 12px;
          height: auto;
        }
      }
      .search-item-right {
        flex: 1;
        padding: 18px 18px 0 28px;
        border-left: 1px solid #e8e8e8;
        display: flex;
        flex-wrap: wrap;
        a {
          font-size: 14px;
          padding: 6px 12px;
          margin-right: 20px;
          cursor: pointer;
          margin-bottom: 18px;
          background: #efefef;
          &:hover {
            color: #fff;
            background: #b1191a;
          }
        }
      }
    }
  }
  .listing-box {
    padding: 24px 42px;
    background: #fafafa;
    border: 1px solid #ececec;
    border-top: none;
    .listing-title {
      font-size: 18px;
    }
    .listing-list {
      display: flex;
      padding-top: 18px;
      align-items: center;
      justify-content: space-between;
    }
    .listing-item {
      box-shadow: 0px 0px 20px 0px rgba(206, 206, 206, 0.5);
      background: #fff;
      display: flex;
      width: 160px;
      height: 72px;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      .listing-number {
        font-size: 18px;
        margin-bottom: 4px;
      }
      .listing-lable {
        font-size: 14px;
      }
    }
  }

  .flex-box-bt {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
  }
  .origin-box {
    width: 728px;
  }

  .chart-line {
    width: 728px;
    height: 180px;
  }

  .tips-box {
    width: 358px;
    button {
      width: 100%;
      background: #b1191a;
      border: none;
    }
  }
  .home-item-title {
    position: relative;
    padding-left: 12px;
    box-sizing: border-box;
    font-size: 20px;
    font-weight: 500;
    color: #c3241c;
    height: 24px;
    line-height: 24px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 24px 0;
    & > div {
      height: 24px;
    }
    .more {
      font-size: 14px;
      cursor: pointer;
    }
  }
  .home-item-title:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 24px;
    background-color: #c3241c;
  }

  .tab-tips-item {
    width: 100%;
    height: 39px;
    line-height: 39px;
    a {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #000;
      border-top: 1px solid #eee;

      .new-item-title {
        display: flex;
        align-items: center;
        .new-item-lin {
          padding-right: 5px;
          text-decoration: none;
          flex-shrink: 0;
        }
        span {
          width: 400px;

          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
